package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexBasis
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val FormLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Light)
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val PersonalDetailsFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier
            .gap(24.px)
    }
}

val FormInputStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(40.px)
            .backgroundColor(if (colorMode.isDark) Colors.input else Colors.LightGray)
            .color(if (colorMode.isDark) Colors.White else Colors.Black)
            .border(0.px)
            .borderRadius(5.px)
            .padding(left = 10.px, right = 20.px)
            .fontSize(14.px)
            .transition {
                property("border-color")
                duration(200.ms)
            }
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val PersonalDetailsGroupColumnStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier
            .gap(20.px)
    }
}

val PersonalDetailsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
            .gap(25.px)
    }
}

val PersonalDetailsHalfWidthStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
    }

    Breakpoint.MD {
        Modifier
            .fillMaxWidth()
            .flexGrow(1)
            .flexShrink(1)
            .flexBasis(0.px)
    }
}

val PersonalDetailsFullWidthStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }
}

val PersonalDetailsPhotoStyle = CssStyle {
    base {
        Modifier.size(90.px)
    }

    Breakpoint.MD {
        Modifier.size(130.px)
    }
}



val DateSelectorStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(40.px)
            .backgroundColor(
                if (colorMode.isDark) {
                    Colors.input
                } else {
                    Colors.LightGray
                }
            )
            .color(
                if (colorMode.isDark) {
                    Colors.White
                } else {
                    Colors.Black
                }
            )
            .border(0.px)
            .borderRadius(5.px)
            .padding(
                left = 10.px,
                right = 50.px
            )
            .fontSize(14.px)
    }

    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val DynamicFieldsContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexWrap(FlexWrap.Wrap)
            .gap(10.px)
    }
}

val PersonalDetailsMainRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexDirection(FlexDirection.Column)
            .gap(16.px)
    }

    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
            .gap(25.px)
    }
}

val PersonalDetailsFieldsStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
    }
}

val PersonalDetailsTwoFieldsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexWrap(FlexWrap.Wrap)
    }
}


val PersonalDetailsFieldsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexWrap(FlexWrap.Wrap)
    }

    Breakpoint.MD {
        Modifier
            .columnGap(25.px)
            .rowGap(25.px)
    }
}


